import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Medal from './Images/Medal.svg';
import { RxCross2 } from "react-icons/rx";
import { FaCheckCircle } from "react-icons/fa";
import Header from "../../Header/Header";
import Getintouch from "./Getintouch";
import Footer from "../../Footer/Footer";

interface UserDetails {
  id: number;
  name: string;
  email: string;
  role: string;
  company_name: string;
  profile: string;
  point: number;
  Time: string;
  DOB: string;
  number: number;
}

interface NewsStructure {
  id: string;
  title: string;
  img: string;
  desc: string;
  date: string;
  PresentMember: string;
  RMBiansOfMeeting: number;
  OtherRMBians: string;
}

const AllRMBianOfMeeting = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const [userdetails, setUserdetails] = useState<UserDetails[]>([]);
  const [newData, setNewData] = useState<NewsStructure[]>([]);
  const [otherRMBIANS, setOtherRMBIANS] = useState<number[]>([]);


 const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 768,
      settings: { slidesToShow: 1 }
    }
  ]
};

 useEffect(() => {
  const fetchAllUserData = async () => {
    try {
      const response = await axios.get(`${api}/auth/allusersinfo`);
      setUserdetails(response.data);

      // Use response.data directly, not userdetails state
      const users = response.data;

      try {
        const today = new Date();
        const month = today.getMonth();
        const date = today.getDate();

        const birthdayUsers = users.filter((user: { DOB: string | number | Date; }) => {
          if (!user.DOB) return false;
          const dob = new Date(user.DOB);
          return dob.getMonth() === month && dob.getDate() === date;
        });

        if (birthdayUsers.length === 0) {
          console.log("No birthdays today.");
          return;
        }

        // Send entire users list to /birthday-message API
        const payload = { users };

        const notifyResponse = await axios.post(`${api}/birthday-message`, payload);
        console.log("Birthday message API response:", notifyResponse.data);
      } catch (error) {
        console.log("Unable to call birthday API:", error);
      }
    } catch (error) {
      console.error("Failed to fetch users:", error);
    }
  };

  fetchAllUserData();
}, [api]);
  useEffect(() => {
    
    const fetchData = async () => {
      try {
        const response = await axios.get<NewsStructure[]>(`${api}/auth/news`);
        const data = Array.isArray(response.data) ? response.data : [response.data];
        console.log('birthday news data ',data);
        setNewData(data);

        if (data.length > 0 && data[0].OtherRMBians) {
          const parsed = data[0].OtherRMBians.split('&').map(Number);
          setOtherRMBIANS(parsed);
        } else {
          setOtherRMBIANS([]);
        }
      } catch (error) {
        console.error("Post Not Found:", error);
      }
    };
    fetchData();
  }, [api]);




 

  // Combine users who are either RMBiansOfMeeting or in OtherRMBians list for slider
  const uniqueRmbianUsers = userdetails.filter(user =>
    newData.some(n => n.RMBiansOfMeeting === user.id) ||
    otherRMBIANS.includes(user.id)
  );
const usersWithLatestNewsDate = uniqueRmbianUsers
  .filter(user => user.role !== 'super-admin')
  .map(user => {
    const userNews = newData.filter(n =>
      n.RMBiansOfMeeting === user.id || n.OtherRMBians.includes(user.id + '')
    );
    const latestNewsDate = userNews.length
      ? new Date(userNews.reduce((max, n) => n.date > max ? n.date : max, userNews[0].date)).getTime()
      : 0;
    return { ...user, latestNewsDate };
  })
  .sort((a, b) => b.latestNewsDate - a.latestNewsDate);
  return (
    <div>
        <Header />
        <div className="bg-[#0F172A] py-16 px-[5%] text-white">


    {/* Hero Section */}
    <div className="text-center mb-12">
      <h2 className="text-3xl sm:text-4xl font-bold text-[#FDBC12] drop-shadow-lg mb-3">
        🌟 Meet the RMBians of the Meetings
      </h2>
      <p className="text-[#CBD5E0] max-w-xl mx-auto text-sm sm:text-base">
        Celebrating the individuals who made the biggest impact during this session.
        Here are the top contributors and active members recognized in our recent meeting.
      </p>
    </div>

    {/* Cards Section */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
      {usersWithLatestNewsDate
        .filter((user) => user.role !== 'super-admin')
        .map((user) => {
          const matchingNews = newData
            .filter(
              (n) =>
                n.RMBiansOfMeeting === user.id ||
                n.OtherRMBians.includes(user.id + '')
            )
            .sort(
              (a, b) =>
                new Date(b.date).getTime() - new Date(a.date).getTime()
            );

          return (
            <div
              key={user.id}
              className="bg-gradient-to-br from-[#1E293B] to-[#334155] p-6 rounded-2xl shadow-md hover:shadow-2xl transition duration-300 border border-[#FDBC12]/20 relative"
            >
              {/* Badge */}
              <span className="absolute top-4 right-4 bg-[#FDBC12] text-[#1E2A3A] text-xs font-bold px-3 py-1 rounded-full shadow">
                RMBian
              </span>

              {/* Profile */}
              <div className="flex flex-col items-center mb-4">
                <div className="w-[100px] h-[100px] rounded-full overflow-hidden border-4 border-[#FDBC12] mb-3 shadow-md">
                  <img
                    src={user.profile ? `${api}/${user.profile}` : '/fallback.jpg'}
                    alt={user.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="text-lg font-bold">{user.name}</h3>
                <p className="text-sm text-[#A0AEC0]">{user.company_name}</p>
              </div>

              {/* News Highlights */}
              <div className="space-y-3 text-sm">
                {matchingNews.map((newsItem) => (
                  <div
      key={newsItem.id}
      className="bg-[#1C2C3E] rounded-md px-4 py-2 text-[#F1F5F9] h-[77px] border border-[#FDBC12]/10 flex flex-col justify-start "
    >
      <div className="text-xs text-[#FDBC12] font-semibold mb-1">
        📅 {newsItem.date.split("T")[0]}
      </div>
      <div className="text-[13px] text-[#CBD5E0]">{newsItem.title}</div>
    </div>
                ))}
              </div>
            </div>
          );
        })}
    </div>
    
  </div>
   {/* Get in touch */}
          <Getintouch />
          <Footer />
    </div>
  
);

};

export default AllRMBianOfMeeting;
